// Feuilles de match (D-049), côté bureau : les matchs joués du club, toutes équipes, pour y
// déposer la feuille de stats FFBB (PDF). Le coach de l'équipe est prévenu et décide si
// les joueuses la voient.
import { clubRecentMatches, matchDocs, type MatchDoc, type TeamMatch } from '../lib/api';
import { localDate } from '../domain/schedule';
import { squadName, type Ctx } from './context';
import { $$, html, mount, toast } from './dom';
import { shortDate } from './format';
import { uploadMatchDocs } from './match-extras';
import { scoreLine } from './team-matches';

export async function renderFeuilles(root: HTMLElement, ctx: Ctx): Promise<void> {
  const club = ctx.adminOf.find(c => c.id === ctx.club?.id) ?? ctx.adminOf[0] ?? ctx.club;
  const teamIds = ctx.teams.filter(t => !club || t.club_id === club.id).map(t => t.id);
  const matches = await clubRecentMatches(teamIds, 45).catch(() => [] as TeamMatch[]);
  const docs = await matchDocs(matches.map(m => m.event_id)).catch(() => [] as MatchDoc[]);
  const teamName = (id: string) => ctx.teams.find(t => t.id === id)?.name ?? '';
  const without = matches.filter(m => !docs.some(d => d.event_id === m.event_id)).length;

  mount(root, html`
    <section class="screen">
      <a class="back" href="#/club">‹ Le club</a>
      <header class="screen-head"><p class="eyebrow">Bureau · stats FFBB</p><h2>Feuilles de match</h2>
        <p class="muted">Dépose les PDF FFBB du match (les 3 d'un coup) : le coach les reçoit et choisit ce que voit l’équipe.</p></header>
      <nav class="seg" aria-label="Feuilles et dérogations"><a href="#/feuilles" aria-current="page">Feuilles de match</a><a href="#/derogations">Dérogations</a></nav>
      ${matches.length ? html`
        <p class="muted small">${matches.length} ${matches.length > 1 ? 'matchs' : 'match'} sur 45 jours · ${without ? `${without} sans PDF` : 'tous les matchs ont leurs PDF'}</p>
        <ul class="ce-rows fm-list">${matches.map(m => {
          const mine = docs.filter(d => d.event_id === m.event_id);
          const date = localDate(new Date(m.events.starts_at));
          return html`<li>
            <a class="fm-main" href="#/e/${m.event_id}/${date}">
              <strong>${squadName(ctx, m.squad_id) ?? teamName(m.events.team_id)} ${m.is_home === false ? 'à' : '–'} ${m.opponent}</strong>
              <span class="muted small">${shortDate(date)}${scoreLine(m) ? ` · ${scoreLine(m)}` : ''}</span>
            </a>
            <span class="btn-row">
              ${mine.length ? html`<span class="chip ${mine.some(d => d.visible) ? 'chip-ok' : 'chip-soft'}">${mine.length} PDF · ${mine.some(d => d.visible) ? 'visible' : 'coach'}</span>` : ''}
              ${mine.length < 3 ? html`<label class="btn btn-ghost btn-sm mx-file">+ PDF<input type="file" accept="application/pdf,image/jpeg,image/png" data-up="${m.event_id}" multiple hidden></label>` : ''}
            </span>
          </li>`;
        })}</ul>`
        : html`<div class="empty"><p class="empty-title">Aucun match joué ces 45 derniers jours.</p></div>`}
    </section>`);

  for (const inp of $$<HTMLInputElement>(root, '[data-up]')) inp.addEventListener('change', async () => {
    const n = await uploadMatchDocs(inp.dataset.up!, inp.files);
    if (n) { toast(`${n > 1 ? `${n} PDF déposés` : 'PDF déposé'} : le coach est prévenu`); await renderFeuilles(root, ctx); }
  });
}
